<template>
    <admin-layout class="tenants">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1>Submit Your Action Project</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item active">Submit your project by June 13th, 2022.</li>
                        </ol>
                    </nav>
                </div>
            </template>

            <hr class="my-0">

            <section class="embed">
                <iframe :src="url" id='frame' width='100%' height='858.6' style='max-width:100%;border:0;box-shadow: 0 0 0 .5px rgba(30, 30, 30, .1), 0px 1px 2px rgb(30, 30, 30, .08);border-radius:3px'></iframe>
            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AppContentPane from "@/Components/AppContentPane";
import AdminLayout from "@/Layouts/AdminLayout";
export default {
    name: "EmbedProjectSubmit",
    components: {AdminLayout, AppContentPane},

    computed: {
        frame(){
            return this.$refs.frame;
        },

        url() {
            console.log(this.current_user);

            var organization = 'N/A';
        
            if (this.current_user.organizations != undefined) {
                if (this.current_user.organizations.length == 0) {
                    organization = 'N/A';
                } else {
                    organization = this.current_user.organizations[0].name;
                }
            }

            return 'https://formcrafts.com/a/xfkztpb?iframe=true&resizer=false&innerHeight=858.6&field17=' + organization + '&field16=' + this.current_user.email + '&field18=' + this.current_user.first_name + ' ' + this.current_user.last_name;
        }
    },

    methods: {
        resizeFrame(){
            setTimeout(() => {
                this.frame.height = '3500px';
            }, 100);
        },
    },

    mounted() {
        this.setTitle("Submit Action Project");
    },

}
</script>
<style lang="scss" scoped>
.embed{
    font-size: 0;
}
.frame{
    width: 100%;
    border: none;
    border-radius: 0 0 6px 6px;
    height: 3500px;
}
</style>
